
import React, { useCallback, useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import { IGetImagesResponse, IImage } from "../../../interfaces/api/IMedia";
import { baseUrl } from "../../../config/apiConfig";
import { useLazyGetOneDownloadTemplateImageQuery } from "../../../services/api/repositories/TemplateMailsRepository";

export default function TableMedia({data}: {data: IGetImagesResponse}) {
    return (
        <div className="table-container">
            <Table className="table list media">
                <thead>
                    <tr>
                    <th className="name key">Nom</th>
                    <th className="description">Description</th>
                    <th className="actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.images.length === 0 && (
                        <tr>
                            <td colSpan={3} className="no-results">
                                Aucun média disponible.
                            </td>
                        </tr>
                    )}
                    {data.images.length > 0 && <TableRow data={data} />}
                </tbody>
            </Table>
        </div>
    );
}

function TableRow({data}: {data: IGetImagesResponse}) {
    const rows = data.images.map((image: IImage) => {
        return (
            <Row image={image} key={image.uuid}/>
        );
    });

    return (
        <>
            {rows}
        </>
    );
}

function Row ({image}: {image: IImage}) {
    const [getOneTemplateImage, {data, isSuccess}] = useLazyGetOneDownloadTemplateImageQuery();

    const handleDownload = useCallback(() => {
        getOneTemplateImage({name: image.name});
    }, [getOneTemplateImage, image]);
    
    const handleCopyUrl = useCallback(() => {
        const url = `${baseUrl}/templates/images/${image.name}`;
        navigator.clipboard.writeText(url);
    }, [image]);

    useEffect(() => {
        if (isSuccess && data && data.data && data.data !== "" && data.name && data.name !== "" && data.mime_type && data.mime_type !== "") {
            const base64Data = data.data;
            const binaryString = window.atob(base64Data);
            const arrayBuffer = new ArrayBuffer(binaryString.length);
            const uint8Array = new Uint8Array(arrayBuffer);
    
            for (let i = 0; i < binaryString.length; i++) {
                uint8Array[i] = binaryString.charCodeAt(i);
            }
        
            const blob = new Blob([uint8Array], {
                type: data.mime_type,
            });
    
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
    
            const extension = data.mime_type.split('/')[1]; 
            a.download = data.name.endsWith(`.${extension}`) ? data.name : `${data.name}.${extension}`;
    
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    }, [data, isSuccess]);
    
    return (
        <tr key={image.uuid}>
            <td className="name key">{image.name}</td>
            <td className="description">{image.description}</td>
            <td className="actions">
                <div className="btns-wrapper">
                    <Button variant="none" size="sm" className="btn-download" title="Télécharger le Média" onClick={() => {handleDownload();}}>
                        <span className="icon"></span>
                        <span className="text">Télécharger</span>
                    </Button>
                    <Button variant="none" size="sm" className="btn-copyURL" title="Copier l'URL du Média" onClick={() => {handleCopyUrl();}}>
                        <span className="icon"></span>
                        <span className="text">Copier URL</span>
                    </Button>
                </div>
            </td> 
        </tr>
    );
}